export default "__VITE_ASSET__e81a51c6__"